module.exports = __webpack_public_path__ + "img/iconPlusWhite.d4b563e9.svg";